import omitBy from 'lodash/omitBy';
import isEmpty from 'lodash/isEmpty';

export default function omitEmpty(object) {
  return omitBy(object, isEmpty);
}
